// extracted by mini-css-extract-plugin
export default {"choose-page-container":"h_Ooo","choosePageContainer":"h_Ooo","heading":"MUpcQ","subtitle":"WwHUd","select":"x0hE8"};